import styled from 'styled-components'

interface IDotProps {
  isCurrent: boolean;
}

export const Container = styled.div`
  width: 90%;
  min-height: 100%;
  margin: 10px;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
`

export const Button = styled.button`
  width: 5%;
  height: 10%;

  background: #fff;
  border-radius: 50%;
  border: none;-
`

export const Embed = styled.iframe`
  width: 100%;
  height: 100%;
  min-width: 80%;
  min-height: 100%;
`

export const Dots = styled.div`
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;

  margin: 0 auto;

  display: none;
  align-items: center;
  justify-content: center;
`

export const Dot = styled.div<IDotProps>`
  width: 10px;
  height: 10px;

  border-radius: 50%;
  background: ${({ isCurrent }) => isCurrent ? '#fff' : 'rgba(255, 255, 255, 0.5)'};

  & + & {
    margin-left: 5px;
  }
`
